var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceBelow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FF3A44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2739 7.27386C13.4251 7.12261 13.4251 6.87739 13.2739 6.72614C13.1226 6.57489 12.8774 6.57489 12.7261 6.72614L13.2739 7.27386ZM6.6127 13C6.6127 13.2139 6.7861 13.3873 7 13.3873L10.4857 13.3873C10.6996 13.3873 10.873 13.2139 10.873 13C10.873 12.7861 10.6996 12.6127 10.4857 12.6127H7.3873V9.51432C7.3873 9.30042 7.2139 9.12702 7 9.12702C6.7861 9.12702 6.6127 9.30042 6.6127 9.51432L6.6127 13ZM12.7261 6.72614L6.72614 12.7261L7.27386 13.2739L13.2739 7.27386L12.7261 6.72614Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceBelow);
export default __webpack_public_path__ + "static/media/price-below.849e293e7cd899fcad56565eebdc3fdf.svg";
export { ForwardRef as ReactComponent };